// extracted by mini-css-extract-plugin
export default {"popup":"PayPopup_popup__wujGj","btns":"PayPopup_btns__ppmRg","submitting":"PayPopup_submitting__n0yeO"};